import { Host, h } from "@stencil/core";
import state from "../store";
import { commonClassesNames } from "../../common/classesNames";
import { exportParts } from "../../common/export-parts";
export class GxgListboxItem {
    constructor() {
        this.disabled = undefined;
        this.icon = undefined;
        this.selected = false;
        this.siblingIsSelected = false;
        this.highlighted = false;
        this.active = false;
        this.index = null;
        this.emitCheckboxChange = true;
        this.value = undefined;
        this.checkbox = false;
        this.checked = false;
        this.mouseOver = false;
    }
    parts = {
        checkbox: "checkbox"
    };
    exportparts;
    el;
    /**
     * (This event is for internal use.)
     */
    itemClicked;
    /**
     * (This event is for internal use.)
     */
    itemLoaded;
    /**
     * (This event is for internal use.)
     */
    itemSelected;
    /**
     * (This event is for internal use.)
     */
    checkboxStateChanged;
    watchPropHandler() {
        this.itemSelected.emit();
    }
    checkboxChangedHandler(e) {
        const checked = e.detail.value;
        this.emitCheckboxChange &&
            this.checkboxStateChanged.emit({
                checkedItem: this.el,
                checked: checked
            });
    }
    handleCheckboxClick = (e) => {
        e.stopPropagation();
        e.target.checked
            ? (this.checked = true)
            : (this.checked = false);
    };
    iconColor() {
        if (this.disabled) {
            return "disabled";
        }
        else if (this.selected) {
            return "primary-enabled";
        }
        else {
            return "auto";
        }
    }
    componentWillLoad() {
        this.attachExportParts();
    }
    attachExportParts = () => {
        const part = this.el.getAttribute("part");
        const exportPartsResult = exportParts(part, this.parts);
        exportPartsResult.length && (this.exportparts = exportPartsResult);
    };
    componentDidLoad() {
        this.itemLoaded.emit({ value: this.value });
    }
    itemClickedFunc(e) {
        this.itemClicked.emit({
            clickedItem: this.el,
            ctrlKey: e.ctrlKey,
            cmdKey: e.metaKey,
            shiftKey: e.shiftKey,
            index: this.index
        });
    }
    onMouseOver() {
        this.mouseOver = true;
    }
    onMouseOut() {
        this.mouseOver = false;
    }
    render() {
        return (h(Host, { class: {
                "has-icon": this.icon !== undefined,
                "no-checkbox": !this.checkbox,
                large: state.large,
                [commonClassesNames["DISABLED_CLASS"]]: this.disabled
            }, onClick: this.itemClickedFunc.bind(this),
            // onMouseOver={this.onMouseOver.bind(this)}
            // onMouseOut={this.onMouseOut.bind(this)}
            exportParts: this.exportparts ? this.exportparts : null }, h("div", { class: { container: true, "form-element": true } }, this.checkbox && !this.disabled ? (h("gxg-form-checkbox", { tabindex: "-1", checked: this.checked, onClick: this.handleCheckboxClick, disabled: this.disabled, part: this.parts.checkbox })) : null, this.icon !== undefined ? (h("gxg-icon", { class: "icon", color: this.iconColor(), size: "regular", type: this.icon })) : null, h("div", { class: "description" }, h("slot", null)))));
    }
    static get is() { return "gxg-list-box-item"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["list-box-item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["list-box-item.css"]
        };
    }
    static get properties() {
        return {
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute disabled the list-box-item"
                },
                "attribute": "disabled",
                "reflect": true
            },
            "icon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Any icon that belongs to Gemini icon library: https://gx-gemini.netlify.app/?path=/story/icons"
                },
                "attribute": "icon",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "selected": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute sets this item as selected"
                },
                "attribute": "selected",
                "reflect": true,
                "defaultValue": "false"
            },
            "siblingIsSelected": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This property is for internal use"
                },
                "attribute": "sibling-is-selected",
                "reflect": true,
                "defaultValue": "false"
            },
            "highlighted": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute sets this item as highlighted"
                },
                "attribute": "highlighted",
                "reflect": true,
                "defaultValue": "false"
            },
            "active": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute sets this item as active (it is as if it was focused)\nOnly one item at a time should be active."
                },
                "attribute": "active",
                "reflect": true,
                "defaultValue": "false"
            },
            "index": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This property is set by the list-box item. It should not be set by the user."
                },
                "attribute": "index",
                "reflect": true,
                "defaultValue": "null"
            },
            "emitCheckboxChange": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute emits the 'checkboxChanged' event every time a checkbox value is changed."
                },
                "attribute": "emit-checkbox-change",
                "reflect": false,
                "defaultValue": "true"
            },
            "value": {
                "type": "any",
                "mutable": false,
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The item value. If value is not provided, the value will be the item innerHTML."
                },
                "attribute": "value",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "checkbox": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute will add a checkbox to the item."
                },
                "attribute": "checkbox",
                "reflect": false,
                "defaultValue": "false"
            },
            "checked": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute will make the checkbox checked."
                },
                "attribute": "checked",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "mouseOver": {}
        };
    }
    static get events() {
        return [{
                "method": "itemClicked",
                "name": "itemClicked",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "(This event is for internal use.)"
                },
                "complexType": {
                    "original": "ItemClicked",
                    "resolved": "{ clickedItem: HTMLGxgListBoxItemElement; ctrlKey: boolean; cmdKey: boolean; shiftKey: boolean; index: number; }",
                    "references": {
                        "ItemClicked": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/list-box-item/list-box-item.tsx",
                            "id": "src/components/list-box-item/list-box-item.tsx::ItemClicked"
                        }
                    }
                }
            }, {
                "method": "itemLoaded",
                "name": "itemLoaded",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "(This event is for internal use.)"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "itemSelected",
                "name": "itemSelected",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "(This event is for internal use.)"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "checkboxStateChanged",
                "name": "checkboxStateChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "(This event is for internal use.)"
                },
                "complexType": {
                    "original": "ItemChecked",
                    "resolved": "{ checkedItem: HTMLGxgListBoxItemElement; checked: boolean; }",
                    "references": {
                        "ItemChecked": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/list-box-item/list-box-item.tsx",
                            "id": "src/components/list-box-item/list-box-item.tsx::ItemChecked"
                        }
                    }
                }
            }];
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "selected",
                "methodName": "watchPropHandler"
            }];
    }
    static get listeners() {
        return [{
                "name": "change",
                "method": "checkboxChangedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=list-box-item.js.map
